var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19872 13.7829L0.546443 0.565399C0.484519 0.458278 0.484519 0.325396 0.546443 0.216873C0.608368 0.109752 0.723152 0.0429687 0.847653 0.0429687L16.1522 0.0429687C16.2767 0.0429687 16.3915 0.109752 16.4534 0.216873C16.484 0.27045 16.5 0.330972 16.5 0.390777C16.5 0.4513 16.4847 0.511137 16.4534 0.565399L8.8011 13.7829C8.73849 13.8901 8.62371 13.9562 8.49989 13.9562C8.37608 13.9562 8.26061 13.8901 8.19872 13.7829Z",
    fill: "#ED2024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select-arrow.c1c51be2f72cc0185e92a5577b428586.svg";
export { ForwardRef as ReactComponent };